import { render, staticRenderFns } from "./DiscussDetail.vue?vue&type=template&id=ee65d49a&scoped=true&"
import script from "./DiscussDetail.vue?vue&type=script&lang=js&"
export * from "./DiscussDetail.vue?vue&type=script&lang=js&"
import style0 from "./DiscussDetail.vue?vue&type=style&index=0&id=ee65d49a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee65d49a",
  null
  
)

export default component.exports